import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './LanguageSwitcher.scss';

const LanguageSwitcher = ({ className = '', scrolled = false }) => {
  const { i18n } = useTranslation();
  
  const currentLanguage = i18n.language;
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  
  return (
    <div className={`language-switcher ${className} ${scrolled ? 'language-switcher--scrolled' : ''}`}>
      <motion.button
        className={`language-switcher__btn ${currentLanguage === 'ro' ? 'active' : ''}`}
        onClick={() => changeLanguage('ro')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        RO
      </motion.button>
      <motion.button
        className={`language-switcher__btn ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        EN
      </motion.button>
    </div>
  );
};

export default LanguageSwitcher;
